(function() {
    'use strict';
    angular
        .module('showcaseApp')
        .factory('PagarMeV5Service', PagarMeV5Service);

    PagarMeV5Service.$inject = ['PagarMeV5Factory'];

    function PagarMeV5Service(PagarMeV5Factory) {
        var service = {
            integrateRecipient: integrateRecipient,
            updateRecipient: updateRecipient,
            hasActiveExternalRecipient: hasActiveExternalRecipient,
            reconnectRecipient: reconnectRecipient,
            generateKycLink: generateKycLink
        };

        return service;

        function integrateRecipient(recipient) {
            return PagarMeV5Factory.integrateRecipient({}, recipient).$promise;
        }

        function updateRecipient(recipient) {
            return PagarMeV5Factory.updateRecipient({}, recipient).$promise;
        }

        function hasActiveExternalRecipient() {
            return PagarMeV5Factory.hasActiveExternalRecipient().$promise;
        }

        function reconnectRecipient() {
            return PagarMeV5Factory.reconnectRecipient({}, {}).$promise;
        }

        function generateKycLink() {
            return PagarMeV5Factory.generateKycLink({}, {}).$promise;
        }
    }
})();
